import { render, staticRenderFns } from "./orgInfo.vue?vue&type=template&id=4541630b&scoped=true&"
import script from "./orgInfo.vue?vue&type=script&lang=js&"
export * from "./orgInfo.vue?vue&type=script&lang=js&"
import style0 from "./orgInfo.vue?vue&type=style&index=0&id=4541630b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4541630b",
  null
  
)

export default component.exports